import { slicedToArray as _slicedToArray, objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import { Dropdown as Dropdown$2 } from './Dropdown.styles.js';

var _excluded = ["placeholderText", "options"];
var Dropdown = function Dropdown(_ref) {
  var _ref$placeholderText = _ref.placeholderText,
    placeholderText = _ref$placeholderText === void 0 ? '' : _ref$placeholderText,
    options = _ref.options,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Dropdown$2, _extends({}, rest, {
    isSearchable: true,
    options: options,
    placeholder: placeholderText,
    styles: {
      // Fixes the overlapping problem of the component
      // This method comes straight from their docs
      menu: function menu(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          zIndex: 26
        });
      }
    }
  })));
};
var DropdownWrapper = function DropdownWrapper(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  useEffect(function () {
    setMounted(true);
  }, [setMounted]);
  return mounted && /*#__PURE__*/React__default.createElement(Dropdown, props);
};
var Dropdown$1 = DropdownWrapper;

export { Dropdown$1 as default };
//# sourceMappingURL=index.js.map
